import { graphql } from "gatsby"
import React from "react"
import Carousel from "../components/carousel"
import ContactBanner from "../components/contactBanner"
import DesignSection from "../components/designSection"
import Footer from "../components/footer"
import Gallery from "../components/gallery"
import Header from "../components/header"
import ScrollingBanner from "../components/heroBanner"
import Layout from "../components/layout"
import Magazine from "../components/magazine"
import Map from "../components/map"
import SEO from "../components/seo"
import Spacer from "../components/spacer"
import SplitSection from "../components/splitSection"
import Team from "../components/team"
import Updates from "../components/updates"
import VideoPlayer from "../components/videoPlayer"

const IndexPage = ({ data: { page }, location }) => {
	const contactInfo = { email: page.email, insta: page.instagram, facebook: page.facebook }
	return (
		<Layout>
			<SEO title='Tapestry' />
			<Header location={location} />
			<ScrollingBanner caption={page.caption} mobileImage={page.mobileIntroductionImage} image={page.introductionImage} />
			<Spacer height='double ' className='m-hide' />
			<Spacer height='double' className='m-hide ' />
			<DesignSection designData={page} />
			<Spacer height='double' />
			<Carousel carouselImages={page.carouselImages} />
			<Spacer height='double' />
			<Team team={page} />
			<Spacer height='double' />
			{page.displayOnHomepage ? <Updates updateInfo={page} /> : null}
			<Spacer height='double' />
			<Map />
			<Spacer height='double' />
			<VideoPlayer />
			<Spacer height='double' />
			<SplitSection splitSection={page} />
			<Spacer />
			<Gallery images={page.gallery} />
			<Spacer />
			{( false ? <Magazine name={page.magazineName} image={page.magazineImage} />:'')}
			<Spacer />
			<ContactBanner contactInfo={contactInfo} contact ctaImage={page.ctaImage} />
			<Spacer className='m-hide' />
			<Footer contactInfo={contactInfo} info={page} />
		</Layout>
	)
}

export default IndexPage

export const query = graphql`
	query pageCopy {
		page: datoCmsTapestryLandingPage {
			ctaImage {
				gatsbyImageData
				alt
			}
			caption
			mobileIntroductionImage {
				gatsbyImageData
				alt
			}
			designQuoteAttribution
			designQuote
			designImageCaption
			carouselImages {
				gatsbyImageData
				url
				alt
			}
			gallery {
				gatsbyImageData
				alt
			}
			designImage {
				gatsbyImageData
				alt
			}
			introductionText
			introductionImage {
				gatsbyImageData
				alt
			}
			magazineName
			magazineImage {
				gatsbyImageData
				alt
			}
			designSubtitle
			splitSectionParagraph
			splitSectionImage {
				gatsbyImageData
				alt
			}
			splitSectionImageCaption
			splitSectionSubtitle
			teamTitle
			teamQuote
			teamImage {
				gatsbyImageData
				alt
			}
			teamImageCaption
			teamMembers {
				name
				memberPosition
				image {
					gatsbyImageData
					alt
				}
				id
			}
			displayOnHomepage
			updatesTitle
			updatesQuote
			updatesVideo
			updatesVideoThumbnail {
				gatsbyImageData
				alt
			}
			updates {
				id
				image {
					gatsbyImageData
					alt
				}
				caption
			}
			previousTitle
			previousUpdates {
				id
				thumbnail {
					gatsbyImageData
					alt
				}
				title
				youtube
			}
			address
			email
			instagram
			facebook
			people {
				email
				name
				phone
			}
		}
	}
`
